import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { queryClient, setTransport } from "@/lib/queryClient";
import { setGeneratedBatchPrefix } from "@shared/inventory/batch-number";
import { DEMO_BATCH_PREFIX } from "@shared/platform/demo-fixture-data";
import { Router } from "../App";
import { StaticDemoViewOnlyBanner } from "@/components/static-demo/view-only-banner";
import { StaticDemoAuthProvider } from "./auth-provider";
import { fixtureTransport } from "./fixture-transport";
import { StaticDemoModeProvider } from "./mode";
import "../index.css";

setTransport(fixtureTransport, { bypassAuth: true });
setGeneratedBatchPrefix(DEMO_BATCH_PREFIX);

function StaticDemo() {
  return (
    <QueryClientProvider client={queryClient}>
      <StaticDemoAuthProvider role="admin">
        <StaticDemoModeProvider>
          <div className="h-screen flex flex-col">
            <StaticDemoViewOnlyBanner />
            <div className="flex-1 min-h-0">
              <Router />
            </div>
          </div>
          <Toaster />
        </StaticDemoModeProvider>
      </StaticDemoAuthProvider>
    </QueryClientProvider>
  );
}

createRoot(document.getElementById("root")!).render(<StaticDemo />);
